import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AfDetailModule, AfRowItemModule } from "@pattonair/auction-framework";
import { MfDialogModule } from "@pattonair/material-framework";
import { AucAuctionDetailComponent } from "./auction.detail.component";

@NgModule({
  declarations: [
    AucAuctionDetailComponent,
  ],
  exports: [
    AucAuctionDetailComponent,
  ],
  imports: [
    BrowserModule,
    AfRowItemModule,
    AfDetailModule,
    MfDialogModule,
  ],
})
export class AucAuctionDetailModule { }